import Util from "@/helper/Utility.js";
//service
import HomeService from '@/module/Home/service/HomeService.js';

export default {
    inject: ["AccountStore"],
    data: function () {
        return {
            isShowPoint: false,
        };
    },
    computed: {
        isInitial: function () {
            return this.AccountStore.state.isInitial;
        },
        isLogin: function () {
            return this.AccountStore.state.isLogin;
        },
        profile: function () {
            return this.AccountStore.state.profile;
        },
        userPoint: function () {
            return this.AccountStore.state.point;
        },
    },
    created: function () {
        this.AccountStore.methods.loginStatus().subscribe(async (status) => {
            if (!status) {
                this.$router.replace('/error');
                return;
            }else{
                let config = await this.getConfig();
                if(config.underconstruction){
                    this.$router.replace('/underconstruction');
                    return;
                }

                this.isShowPoint = config.main?.point || false;

                // let isUnderContruction = await this.getConfigUnderContruction();
                // if(isUnderContruction){
                //     this.$router.replace('/underconstruction');
                // }
            }

            if (Util.isFunction(this.onAccountInit)) {
                this.onAccountInit();
            }
        });
    },
    methods: {
        setUpdatePoint: function (point) {
            this.AccountStore.methods.setUpdatePoint(point);
        },
        setUpdateProfile: function (profile) {
            this.AccountStore.methods.setProfile(profile);
        },
        getConfig: function () {
            return new Promise((resolve) => {
                HomeService.apiGetMainConfig()
                    .subscribe({
                        next: (res) => {
                            // console.log('config', res)
                            resolve(res);
                        },
                        error: (err) => {
                            this.errorApi(err);
                            resolve(null);
                        }
                    });
            });
        },
    },
}
